import { makeAutoObservable } from 'mobx';
import { CartProductPricesType, IDelivery } from '@features/cart/typescript';

export default class CartDeliveryState {
  public customPrice: string;

  public deliveryType: string;

  public deliveryTypeId: string;

  public image: string;

  public isAssembleAvailable: boolean;

  public isBringingAvailable: boolean;

  public isPaidOnDelivery: boolean;

  public isTaxAvailable: boolean;

  public isVatAvailable: boolean;

  public name: string;

  public nameLanguageKey: string;

  public other: string;

  public parcelLocker: string;

  public posAddress: string;

  public positionId: string;

  public prices: CartProductPricesType;

  public quantity: number;

  public type: string;

  constructor(delivery: IDelivery) {
    makeAutoObservable(this);

    this.customPrice = delivery.customPrice;
    this.deliveryType = delivery.deliveryType;
    this.deliveryTypeId = delivery.deliveryTypeId;
    this.nameLanguageKey = delivery.nameLanguageKey;
    this.image = delivery.image;
    this.isAssembleAvailable = delivery.isAssembleAvailable;
    this.isBringingAvailable = delivery.isBringingAvailable;
    this.isPaidOnDelivery = delivery.isPaidOnDelivery;
    this.isTaxAvailable = delivery.isTaxAvailable;
    this.isVatAvailable = delivery.isVatAvailable;
    this.name = delivery.name;
    this.other = delivery.other;
    this.parcelLocker = delivery.parcelLocker;
    this.posAddress = delivery.posAddress;
    this.positionId = delivery.positionId;
    this.prices = delivery.prices;
    this.quantity = delivery.quantity;
    this.type = delivery.type;
  }
}
